import GraticuleClass, * as GraticuleModule from './../../node_modules/ol/layer/Graticule.js';

// Create a wrapper class
class Graticule extends GraticuleClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in GraticuleModule) {
    if (key !== "default") {
        Graticule[key] = GraticuleModule[key];
    }
}

export default Graticule;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/layer/Graticule.js';